/**
 * 错误码
 */
export enum ErrorCode {
    ClientSuccess = 0,
    
    //成功
    Success = 200,


    //客户端报错,区别于服务器 客户端报错为负数
    /**
     * 客户端未知错误
     */
    ErrClientUnknown = -999,
    ErrNeedAuth = -998,


    /**
     * 平台操作失败
     */
    ErrPlatformCommon = -800,

    /**
     * 平台没实现
     */
    ErrPlatformNotImpl = -801,
    /**
     * 平台不支持
     */
    ErrPlatformNotSupport = -802,

    /**
     * 平台分享失败
     */
    ErrPlatformShareFailed = -810,


    /**
     * 存储桶请求失败
     */
    ErrBucketOperation = -101,
    /**
     * 存储桶权限错误
     */
    ErrBucketAuth = -102,

    
   
    //网络错误
    NotFound = 404,
    InternalError = 500,

    //无效的jwt认证信息
    MissingJWT = 401,

    //user
    UserNotFound = 1001,


    //game
    MoneyLack = 1100,
    UserLoginFail = 1101,
    GameLaunchFail = 1102,
    TransferStatusFail = 1103,
    VipLimit = 1112,

    //asset
    NotAvailableBankInfo = 1201,
    ErrAssetFailed = 1202,

    //user
    ErrUserNotFound = 1301,
    ErrPwdConfirmError = 1302,
    ErrPwdError = 1303,
    ErrSetPwdError = 1304,
    ErrorNotBindPhone = 1307,

    //pay
    ErrPayPayFail = 1401,
    ErrPayBindBank = 1402,
    ErrPayBindCardExistence = 1403,
    ErrPayAlreadyBinding = 1404,
    ErrPayNotBindData = 1405,
    ErrPayRepayFail = 1406,
    ErrPayRegisterFail = 1407,
    ErrPayGetBankListFail = 1408,
    ErrPayCardNotFound = 1409,



    // auth
    ErrAuthFail = 2001,
    ErrTokenExpired = 2002,
    ErrPasswordInvalid = 2003,
    ErrCaptchaInvalid = 2004,
    ErrRegisterFailed = 2005,
    ErrRegisterPhone = 2006,
    ErrRegisterUsername = 2007,
    ErrRegisterPhoneAndPassword = 2008,
    ErrHttpHeaderInvalid = 2009,
    ErrLoginUsernameFailed = 2010,
    ErrLoginPasswordFailed = 2011,
    ErrOtherDeviceLogin = 2012,
    ErrTokenInvalid = 2013,
    ErrAuthUsernameInvalid = 2014,
    ErrUserIpFailed = 2016,
    ErrAuthLoginFailed = 2017,


    //sms
    ErrSmsSendFail = 3001,


    //net
    ErrNetConnectFail = 9991,
    ErrNetReadFail = 9992,
    ErrNetWriteFail = 9993,


    

}